import {
  BrewGuideSteps,
  RecipeMenu,
  useSlideOverDialogContext,
} from "@bluebottlecoffee/design-system/components";
import { useCart } from "@chordcommerce/react-autonomy";
import type { Product } from "@bluebottlecoffee/design-system/components/lib/types";
import { FunctionComponent } from "react";
import { toHTML } from "@portabletext/to-html";
import {
  DereferencedRecipeMenu,
  toRecipeMenuProps,
} from "../lib/transformers/recipe-menu";
import useVariantPrice from "../lib/chord/hooks/components/use-variant-price";
import useVariantAvailability from "../lib/chord/hooks/components/use-variant-availability";
import { BrewGuideStepsModuleProjection } from "../lib/sanity/recipe-menu-queries";
import { toBrewGuideProps } from "../lib/transformers/detail-page-overview";

interface BrewGuideRecipeMenuProps {
  lang: string;
  region: string;
  data: DereferencedRecipeMenu | BrewGuideStepsModuleProjection;
}

export const BrewGuideRecipeMenu: FunctionComponent<
  BrewGuideRecipeMenuProps
> = ({ lang, region, data }) => {
  const { setActiveContentType } = useSlideOverDialogContext();
  const { addToCart: chordAddToCart } = useCart();

  const useCartProps = {
    useVariantPrice,
    useVariantAvailability,
    addToCart: async (product: Product) => {
      await chordAddToCart({ sku: product.variants[0].sku, quantity: 1 });
      setActiveContentType("minicart");
    },
  };

  return (
    <>
      {data._type === "brewGuideStepsModule" && (
        <BrewGuideSteps
          heading={toHTML(data.heading[lang])}
          bgColor={data?.bgColor}
          showEquipment
          showMenu
          brewGuides={data.brewGuides.map(
            (guide) =>
              toBrewGuideProps({
                data: guide,
                lang,
                region,
                useCartProps,
              }).brewGuide,
          )}
        />
      )}

      {data._type === "recipeMenu" && (
        <RecipeMenu
          {...toRecipeMenuProps({
            data,
            lang,
            region,
            useCartProps,
          })}
          showEquipment
        />
      )}
    </>
  );
};
